import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Robustand = () => {
  return (
    <div className="Robustand p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Our Exceptional React Native App Development Services</h2>
                        <p>Grow your business with our user-oriented React Native app development services, accurately designed for a competitive advantage. Our expert React Native developers guarantee a seamless user experience while creating feature-rich mobile apps. Dive into our collection of React Native App Development services and let innovation determine your success.</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your React Native App</Link>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
                        <div className="robustscroll">
                        <div className="robust-box">
                            <div className="robust-content">
                                <h4>React Native App Design</h4>
                                <p>Raise your app's aesthetics with TekRevol's complete design services. From creating wireframes and models to providing spectacular user interfaces, our expert React Native app developers use tools like Atom, Nuclide, Flow, and Visual Studio Code for an effortless user experience.</p>
                            </div>
                            <div className="robust-content">
                                <h4>React Native App Development</h4>
                                <p>Experience the highest quality Android and iOS development with our advanced react backend frameworks, encompassing Node.js, Kinvey, Express.js, Django, and Firebase. Our DevOps culture and agile methodologies ensure excellent results, guaranteeing a remarkable return on investment.</p>
                            </div>
                            <div className="robust-content">
                                <h4>React Native App Maintenance</h4>
                                <p>Launch your enterprise or startup with our consulting and maintenance services. It doesn't matter what business niche you possess; our virtual team of React Native app developers and consultants quickly adjusts to variations, fixes bugs, and closes loopholes without needing devoted workspaces or hiring permanent staff.</p>
                            </div>
                        </div>
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Robustand